// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { MessageServerContext } from "@lib/messaging/MessageServerContext";
import { IRemoteRpcHub } from "@lib/messaging/rpc/IRemoteRpcHub";
import { IRpcContext } from "@lib/messaging/rpc/IRpcContext";

export type RpcContextFactoryDetails = {
  isNotification: boolean;
  remoteRpcHub: IRemoteRpcHub;
};

export interface IRpcContextFactory<TRpcContext extends IRpcContext>
{
  createRpcContext(context: MessageServerContext, details: RpcContextFactoryDetails): TRpcContext;
}